export const enum paymentStateType {
    renderWidget = "renderWidget",
    tryAgain = "tryAgain",
    error = "error",
    cancelled = "cancelled",
    cancelledWithoutPayment = "cancelledWithoutPayment",
    paymentInProcess = "paymentInProcess",
    wait = "wait",
    afterPayment = "afterPayment",
}

export const bookingStatusPaymentInProcess = ["not_paid", "pay_started"]
